import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  RadioGroup,
  Stack,
  Radio,
  Text,
  Textarea,
} from "@chakra-ui/react";
import React, {useState} from "react";

type CancellationModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (reason: string, comment?: string) => void;
};

export const CancelModal: React.FC<CancellationModalProps> = ({isOpen, onClose, onConfirm}) => {
  const [selectedReason, setSelectedReason] = useState<string>("");
  const [otherComment, setOtherComment] = useState<string>("");

  const handleConfirm = () => {
    onConfirm(selectedReason, otherComment);
    onClose();
  };

  const options = [
    {value: "Too Expensive"},
    {value: "Not Using Anymore"},
    {value: "Switched Services"},
    {value: "Lack of features"},
    {value: "Technical issues"},
    {value: "Other reason"}
  ]

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay/>
      <ModalContent>
        <ModalHeader>Cancel Subscription</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <Text>Please tell us a reason for cancellation to make NotionSender better</Text>
          <RadioGroup onChange={setSelectedReason} value={selectedReason}>
            <Stack direction="column" mt={4} spacing={3}>
              {options.map((op) => <Radio key={op.value} value={op.value}>{op.value}</Radio>)}
            </Stack>
          </RadioGroup>

          <Textarea
            placeholder="Please provide additional details here (optional)"
            mt={4}
            value={otherComment}
            onChange={(e) => setOtherComment(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} isDisabled={!selectedReason} onClick={handleConfirm}>
            <span>Confirm</span>
          </Button>
          <Button variant="ghost"  onClick={onClose}><span>Cancel</span></Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
